<template>
	<div>
		<transition name="modal">
			<div v-if="blockUi" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container text-center">
						<span class="fa fa-spinner fa-pulse fa-3x fa-fw"></span>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
	import { axios } from "./store";

	export default {
		name: "block-ui",
		data() {
			return {
				blockUi: false
			};
		},
		mounted() {
			const that = this;
			let counter = 0;
			axios.interceptors.request.use(
				function(config) {
					counter++;
					that.blockUi = counter !== 0;
					return config;
				},
				function(error) {
					counter--;
					that.blockUi = counter !== 0;
					return Promise.reject(error);
				}
			);

			axios.interceptors.response.use(
				function(response) {
					counter--;
					that.blockUi = counter !== 0;
					return response;
				},
				function(error) {
					counter--;
					that.blockUi = counter !== 0;
					return Promise.reject(error);
				}
			);
		}
	};
</script>


<style scoped>
	.modal-mask {
		position: fixed;
		overflow: auto;

		z-index: 200;
		top: 0;
		left: 0;

		width: 100%;
		height: 100%;

		background-color: rgba(0, 0, 0, 0.3);
		display: table;
		transition: opacity 0.3s ease;
	}

	.modal-wrapper {
		display: table-cell;
		vertical-align: middle;
		margin: auto;
	}

	.modal-container {
		margin: 0px auto;
		padding: 20px 30px;
		transition: all 0.3s ease;
		font-family: Helvetica, Arial, sans-serif;
	}

	/*
	 * The following styles are auto-applied to elements with
	 * transition="modal" when their visibility is toggled
	 * by Vue.js.
	 *
	 * You can easily play with the modal transition by editing
	 * these styles.
	 */

	.modal-enter {
		opacity: 0;
	}

	.modal-leave-active {
		opacity: 0;
	}

	.modal-enter .modal-container,
	.modal-leave-active .modal-container {
		-webkit-transform: scale(1.1);
		transform: scale(1.1);
	}
</style>
